import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

const SOCKET_URL = `${process.env.REACT_APP_API_URL}:8061/ws`;

let client: Client | null = null;

export function getStompClient(): Client {
    if (!client) {
        client = new Client({
            webSocketFactory: () => new SockJS(SOCKET_URL),
            reconnectDelay: 5000,
            onConnect: () => console.log("✅ Conectado al WebSocket"),
            onStompError: (frame) => console.error("❌ STOMP Error:", frame.body),
            onWebSocketError: (evt) => console.error("❌ WebSocket Error:", evt),
        });
        client.activate();
    }
    return client;
}
